import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { Info } from 'lucide-react'
import { useEffect, useState } from 'react'
import React from 'react'
import { Skeleton } from "@/components/ui/skeleton"
import { getShopActiveUsers } from '@/requests/analytics'
import { useShop } from '@/context/shop-context'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from '@/hooks/use-translation'

export const ActiveUsersAnalyticsCard = () => {
  const [activeUsers, setActiveUsers] = React.useState(0)
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const {activeShop} = useShop()
  const { t } = useTranslation()

  const { data, isLoading } = useQuery({
    queryKey: ['analytics.shop.activeUsers', activeShop?._id],
    queryFn: () => getShopActiveUsers(activeShop?._id || ''),
    enabled: !!activeShop?._id,
  })

  useEffect(() => {
    if (data) {
      setActiveUsers(data.visitors)
    } else {
      setActiveUsers(0)
    }
  }, [data])

  return (
    <Card>
      <CardHeader className='flex flex-row items-center justify-between space-y-0 pb-2'>
        <CardTitle className='text-sm font-medium'>
          {t('Active Now')}
        </CardTitle>
        <TooltipProvider delayDuration={0}>
            <Tooltip open={tooltipOpen} onOpenChange={setTooltipOpen}>
              <TooltipTrigger asChild>
                <Button 
                  variant='ghost' 
                  size='icon' 
                  className='h-8 w-8 p-0'
                  onClick={() => setTooltipOpen(!tooltipOpen)}
                >
                  <Info className='h-4 w-4 text-muted-foreground' />
                </Button>
              </TooltipTrigger>
              <TooltipContent side='top'>
                {t('Number of users currently active on your site.')}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
      </CardHeader>
      <CardContent>
        <div className='text-2xl font-bold'>{isLoading ? <Skeleton className="h-6 w-[100px] mb-2" /> : activeUsers}</div>
      </CardContent>
    </Card>
  )
}